<template>
    <div ref="overlay" class="tooltip-overlay" v-on:click="close">
        <div ref="container" class="tool-container" :style="containerStyle">
            <div class="tool-wrapper" >
                <div class="tool-items">
                    <a v-on:click="shareOnFacebook" class="tool-item">
                        <i class="fa fa-facebook"></i>
                    </a>
                    <a v-on:click="shareOnLinkedIn" class="tool-item">
                        <i class="fa fa-linkedin"></i>
                    </a>
                    <a v-on:click="shareInMail" :href="mailHref" class="tool-item">
                        <i class="fa fa-envelope"></i>
                    </a>
                </div>
                <div class="arrow-down" ref="arrow" :style="arrow"></div>
            </div>
        </div>
    </div>
</template>

<script>

import {LeadBus} from '../router/index';

const baseFB = 'https://www.facebook.com/sharer/sharer.php?u=';
const baseLI = 'https://www.linkedin.com/shareArticle?mini=true&url=';

export default {

    props: {
        anchor: {},
        presentation: {},
        currentSlide: {},
        slideList: {}
    },

    data() {
        return {
            top: 0,
            left: 0,
            arrowLeft: 0
        }
    },

    computed: {
        getSlideImageLink() {
            if (this.slideList) {
                return this.slideList[this.currentSlide].url;
            }
        },

        mailHref() {
            return 'mailto:?&body=' + encodeURI(this.$t("str.ImViewingAnInterestingPresentationAt") + location.href);
        },

        containerStyle() {
            return {
                top: this.top + 'px',
                left: this.left + 'px'
            };
        },

        arrow() {
            return {
                marginLeft: this.arrowLeft + 'px'
            }
        }
    },

    mounted() {
        if (!this.anchor) {
            return;
        }

        this.top = this.anchor.offsetTop - this.$refs.container.clientHeight - 5;
        this.left = this.anchor.offsetLeft - this.$refs.container.clientWidth / 2;

        // If overflow on the right side
        if (this.left + this.$refs.container.clientWidth > this.$refs.overlay.clientWidth) {
            let shift = this.left - this.$refs.overlay.clientWidth + this.$refs.container.clientWidth + 5
            this.arrowLeft = this.$refs.container.clientWidth / 2 - this.$refs.arrow.clientWidth / 2 + shift;
            this.left -= shift;
        } else { // No overflow
            this.arrowLeft = this.$refs.container.clientWidth / 2 - this.$refs.arrow.clientWidth / 2;
        }

    },

    methods: {
        shareOnFacebook() {
            window.open(encodeURI(`${baseFB}${this.getSlideImageLink}`));
            LeadBus.$emit('recordLead', {
                type: 'shared-on',
                data: {
                    sharedon: 'facebook',
                    onSlideId: this.currentSlide
                }
            });
        },

        shareOnLinkedIn() { 
            window.open(encodeURI(`${baseLI}${this.getSlideImageLink}&title=${this.presentation.title}&summary=${this.presentation.description}&source=`));
            LeadBus.$emit('recordLead', {
                type: 'shared-on',
                data: {
                    sharedon: 'linkedin',
                    onSlideId: this.currentSlide
                }
            });
        },

        shareInMail() {
            LeadBus.$emit('recordLead', {
                type: 'shared-on',
                data: {
                    sharedon: 'email',
                    onSlideId: this.currentSlide
                }
            });
        },

        close() {
            this.$emit('close');
        }
    },

    created() {
        window.onresize = () => {
            this.close();
        };
    }
};

</script>

<style lang="scss">

.tooltip-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .tool-container {
        position: absolute;
        box-sizing: content-box;
    }

    .tool-wrapper {
        .tool-items {
            padding: 0 5px;
            background-color: #d4451d;
            display: inline-block;
            white-space: nowrap;

            .tool-item {
                cursor: pointer;
                text-align: center;
                padding: 10px;
                display: inline-block;

                .fa {
                    font: normal normal normal 14px/1 FontAwesome;
                    color: #fff;
                }
            }
        }
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #d4451d;
    }
}

</style>



// WEBPACK FOOTER //
// ShareOptions.vue?3b5695fc